import { Star } from "lucide-react";

export function StarRating({ value = 0, size = 16, showValue = false, className = "" }) {
  const rounded = Math.round(value * 2) / 2;
  return (
    <div className={`inline-flex items-center gap-1 ${className}`} data-testid="star-rating">
      <div className="flex items-center">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star
            key={i}
            width={size}
            height={size}
            className={
              i <= Math.floor(rounded)
                ? "fill-amber-500 text-amber-500"
                : i - 0.5 === rounded
                ? "fill-amber-500/50 text-amber-500"
                : "text-slate-300"
            }
          />
        ))}
      </div>
      {showValue && <span className="text-sm font-semibold text-slate-800">{value.toFixed(1)}</span>}
    </div>
  );
}
